// extracted by mini-css-extract-plugin
module.exports = {"main":"Dungeon_main__2iC3M","win":"Dungeon_win__2DyUl","fail":"Dungeon_fail__1mvWt","init":"Dungeon_init__i_OZJ"};